module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner_stores/banner_stores_an-0c9b4f80f3af4cddf6c2028f7bbd601a.jpg";